<template>
  <el-dialog
    :title="$t('text.reset_password') + ' (' + user.userName + ')'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    class="reset-password"
    width="480px"
  >
    <el-form
      :model="form"
      status-icon
      :rules="rules"
      ref="form"
      :label-width="labelWidth"
    >
      <el-form-item :label="$t('text.new_password')" prop="pass">
        <el-input type="password" v-model="form.pass"></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.confirm_password')" prop="checkPass">
        <el-input type="password" v-model="form.checkPass"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" :loading="loading" @click="save()">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('text.please_enter_password')))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('text.please_enter_password_again')))
      } else if (value !== this.form.pass) {
        callback(new Error(this.$t('text.password_inconsistent')))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      loading: false,
      user: {},
      form: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  computed: {
    labelWidth() {
      if (this.$store.state.locale.currentLocale === 'de') {
        return 130 + 'px'
      } else if (this.$store.state.locale.currentLocale === 'fr') {
        return 150 + 'px'
      } else {
        return 120 + 'px'
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.handleResetPassword()
        }
      })
    },
    handleResetPassword() {
      this.loading = true
      let params = {
        username: this.user.userName,
        password: this.form.pass
      }
      ApiService.ResetPassword(this.user.userId, params)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Failed'
          })
        })
    }
  }
}
</script>
